enum ErrorFeedbackOptionsEnum {
  'i_dont_understand_this_error' = 'i_dont_understand_this_error',
  'i_understand_this_error_but_dont_know_how_to_fix_it' = 'i_understand_this_error_but_dont_know_how_to_fix_it',
  'that_is_not_an_errorr' = 'that_is_not_an_errorr',
  'other' = 'other',
}
enum InvoiceFeedbackOptionsEnum {
  'i_dont_understand_how_to_check_if_the_invoice_data_in_my_invoicing_system_matches_the_portal_data' = 'i_dont_understand_how_to_check_if_the_invoice_data_in_my_invoicing_system_matches_the_portal_data',
  'i_dont_understand_the_errors_in_this_invoice' = 'i_dont_understand_the_errors_in_this_invoice',
  'i_think_the_errors_shown_in_this_invoice_are_incorrect' = 'i_think_the_errors_shown_in_this_invoice_are_incorrect',
  'other' = 'other',
}

export const ERROR_FEEDBACK_OPTIONS: Option[] = [
  {
    id: ErrorFeedbackOptionsEnum.i_dont_understand_this_error,
    label: "I don't understand this error",
  },
  {
    id: ErrorFeedbackOptionsEnum.i_understand_this_error_but_dont_know_how_to_fix_it,
    label: "I understand this error but don't know how to fix it",
  },
  {
    id: ErrorFeedbackOptionsEnum.that_is_not_an_errorr,
    label: 'That is not an error',
  },
  {
    id: ErrorFeedbackOptionsEnum.other,
    label: 'Other (specify in the comments if needed)',
  },
];
export const INVOICE_FEEDBACK_OPTIONS: Option[] = [
  {
    id: InvoiceFeedbackOptionsEnum.i_dont_understand_how_to_check_if_the_invoice_data_in_my_invoicing_system_matches_the_portal_data,
    label:
      "I don't understand how to check if the invoice data in my invoicing system matches the Portal data",
  },
  {
    id: InvoiceFeedbackOptionsEnum.i_dont_understand_the_errors_in_this_invoice,
    label: "I don't understand the errors in this invoice",
  },
  {
    id: InvoiceFeedbackOptionsEnum.i_think_the_errors_shown_in_this_invoice_are_incorrect,
    label: 'I think the errors shown in this invoice are incorrect',
  },
  {
    id: InvoiceFeedbackOptionsEnum.other,
    label: 'Other (specify in the comments if needed)',
  },
];

export interface Option {
  id: string;
  label: string;
}
